export function formatProgressionExample(title: string, artist: string, year?: number): string {
  return `${title} — ${artist}${year ? ` (${year})` : ''}`;
}
